export const OfferTypes = {
  PRIME: 'PRIME',
  NON_PRIME: 'NON_PRIME',
};
